import React, { Component } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";

class Terms extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="about-page">
          <div className="about-contain">
            <div className="title"></div>
            <div className="about-tent">
              <div className="left"></div>
              <div className="right">
                <h1>Folksy's Terms of Use</h1>
                <p>
                  <b>Terms of Use</b>
                </p>
                <p>
                  We have tried to make the terms of use on Folksy simple to
                  understand and as useful and fair as possible. We want terms
                  that you understand and can comply with. If you have any
                  thoughts on how we can improve our terms then please do
                  contact us by raising a support ticket.
                </p>
                <p>
                  <b>Definitions and Notification of Changes</b>
                </p>
                <p>
                  By using the Folksy.com website [“Folksy”] and all
                  sub-domains, which are a service of Folksy Ltd., you are
                  agreeing to be bound by the following terms and conditions
                  [the Terms of Use” or “The Agreement”].
                </p>
                <p>
                  Folksy may change these terms at any time by posting changes
                  online. Please review these terms regularly to ensure you are
                  aware of any changes made by Folksy. Your continued use of
                  Folksy.com after changes are posted means you agree to be
                  legally bound by these terms as updated and/or amended.
                </p>
                <p>
                  <b>General Terms</b>
                </p>
                <p>
                  1. You must be 18 years of age or older or you will not be
                  able to enter into a legally binding contract to buy or sell
                  via Folksy.
                </p>
                <p>
                  1.2. If you register membership as a business [as a sole
                  trader or partnership] on Folksy you must guarantee that you
                  personally have the authority of the business to agree to the
                  terms of use.{" "}
                </p>
                <p>
                  1.3. These terms shall be governed by and interpreted in
                  accordance with the law of England and Wales.
                </p>
                <p>
                  <b>Behaviour</b>
                </p>
                <p>
                  2. You must not use Folksy for any illegal or unauthorized
                  purpose and you agree to comply with all ‘local’ laws
                  regarding online conduct and acceptable content such as libel
                  law and must comply with all local jurisdiction.
                </p>
                <p>
                  3. You must not breach any laws, sell any counterfeit items or
                  otherwise infringe the copyright, trade mark or other rights
                  of third parties.
                </p>
                <p>
                  4. You must not threaten, intimidate, harass or otherwise
                  abuse any other Folksy user.
                </p>
                <p>
                  5. You are responsible for maintaining that the content you
                  submit is your own and is not owned by others.
                </p>
                <p>
                  6. You are solely responsible for your behaviour and conduct
                  on Folksy.com including use of all content and data including
                  images [graphics and photos], audio and video clips, links and
                  text [such as conversations] that you post to the Folksy.com
                  website.
                </p>
                <p>
                  7. You must not modify or adapt or ‘hack’ Folksy.com or seek
                  to create another website or communication to users that
                  implies it is associated to Folksy.com
                </p>
                <p>
                  8. You must not produce unwanted communications [spam] to
                  other users of Folksy.
                </p>
                <p>9. You are responsible for keeping your password secure.</p>
                <p>
                  10. You must not transmit or seek to transmit any viruses or
                  worms or any code that seeks to alter the behaviour of the
                  Folksy site or that is in any way destructive.
                </p>
                <p>
                  <b>Liability</b>
                </p>
                <p>
                  11. Under no circumstances will Folksy Ltd. be liable for any
                  of the following losses or damage (whether such losses where
                  foreseen, foreseeable, known or otherwise): (a) loss of data;
                  (b) loss of revenue or anticipated profits; © loss of
                  business; (d) loss of opportunity; (e) loss of goodwill or
                  injury to reputation; (f) losses suffered by third parties; or
                  (g) any indirect, consequential, special or exemplary damages
                  arising from the use of Folksy regardless of the form of
                  action.
                </p>
                <p>
                  <b>Goods for Sale - Handmade</b>
                </p>
                <p>
                  12. If you seek to sell products then all goods sold as
                  “handmade” must be deemed not to have been produced through
                  “mass production” methods and must be the original design or
                  produce of the seller. See What can I sell on Folksy? for our
                  policy on what is allowed for sale.
                </p>
                <p>
                  13. You must not list prohibited items – for a list of such
                  items please refer to prohibited items list Folksy reserves
                  the right to change this list at any time and without notice.
                </p>
                <p>
                  <b>Content and Copyright</b>
                </p>
                <p>
                  14. You [“the user”] in using Folksy allow Folksy the right to
                  re-use, edit, modify, re-purpose and re-publish the content.
                  “You” retain rights over copyright of all such content yet
                  provide a license for Folksy to use this content both on and
                  offline in perpetuity (see also point 27.).
                </p>
                <p>
                  15. You must not post, list or upload false, inaccurate,
                  misleading or defamatory content (including personal
                  information).
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Terms;
